export const SITE_URL = "https://cirurgiaplasticafoz.com.br";

export function pageHead({
  title,
  description,
  path,
  image = "/og-image.jpg",
  type = "website",
}: {
  title: string;
  description: string;
  path: string;
  image?: string;
  type?: string;
}) {
  const url = `${SITE_URL}${path}`;
  const absImage = image.startsWith("http") ? image : `${SITE_URL}${image}`;
  return {
    meta: [
      { title },
      { name: "description", content: description },
      { property: "og:title", content: title },
      { property: "og:description", content: description },
      { property: "og:type", content: type },
      { property: "og:url", content: url },
      { property: "og:image", content: absImage },
      { name: "twitter:card", content: "summary_large_image" },
      { name: "twitter:title", content: title },
      { name: "twitter:description", content: description },
      { name: "twitter:image", content: absImage },
    ],
    links: [{ rel: "canonical", href: url }],
  };
}
